<template>
  <div class="party">
    <ul>
      <li v-for="(part,index) in parts" :key="'part' + index">
        <div class="img"><img :src="part.bgUrl"/></div>
        <div class="text">
          <div class="title">{{part.name}}</div>
          <div class="desc">{{part.desc}}</div>
          <div class="opt">
            <i @click="toDetail" :pId="part.id">查看详情<a-icon type="caret-right" /></i>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>

export default {
  data () {
    return {
      parts: [
        {
          id: '1',
          bgUrl: 'http://fundation.goldmantis.com:8444/files/news/part11.png',
          name: '苏州金螳螂公益慈善基金会党支部简介',
          desc: '苏州金螳螂公益慈善基金会党支部成立于2019年4月，隶属于苏州市社会组织党委。党支部在上级党组织的领导下，以党建为中心，带动基金会日常工作的开展，积极探索党组织发挥的载体作用，加强文化建设，促进了基金会内部融合、基金会与社会的和谐，为基金会致力于公益慈善工作提供了强有力的组织保障'
        }
      ]
    }
  },
  name: 'party',
  components: {
  },
  methods: {
    toDetail () {
      var item = event.currentTarget,
          pId = item.getAttribute('pId');
      this.$router.push("partd/" + pId);
    }
  },
}
</script>
<style lang="scss" scoped>
  @import '../../scss/views/about';
</style>